import { render, staticRenderFns } from "./UploadPreview.vue?vue&type=template&id=24d9319b&scoped=true"
import script from "./UploadPreview.vue?vue&type=script&lang=js"
export * from "./UploadPreview.vue?vue&type=script&lang=js"
import style0 from "./UploadPreview.vue?vue&type=style&index=0&id=24d9319b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9319b",
  null
  
)

export default component.exports